import { type App, defineAsyncComponent } from 'vue'

const components = {
  TemplateCard: defineAsyncComponent(() => import('./TemplateCard.vue')),
  TemplateNewDialog: defineAsyncComponent(() => import('./TemplateNewDialog.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
